// src/components/GroupHeader.jsx
import React from 'react';
import { Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const GroupTitle = styled(Typography)(({ theme }) => ({
  fontSize: '0.7rem',
  fontWeight: 500,
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  color: theme.palette.mode === 'dark' 
    ? 'rgba(255, 255, 255, 0.5)'
    : 'rgba(0, 0, 0, 0.5)',
  padding: theme.spacing(1, 2, 0.5, 2),
  marginTop: theme.spacing(1)
}));

const GroupHeader = ({ title }) => {
  return (
    <Box>
      <GroupTitle>{title}</GroupTitle>
    </Box>
  );
};

export default GroupHeader;